import {
  Condition,
  LoyaltyEarnedMeasureOption,
} from "@redotech/redo-model/return-flow/condition";
import {
  loyaltyEarnedFromModel,
  validateLoyaltyEarnedCondition,
  type LoyaltyEarnedState,
} from "@redotech/redo-model/return-flow/condition-validate";
import * as React from "react";
import { ConditionType, ConditionTypeDetailsProps } from "../condition";

export const LOYALTY_EARNED = (
  Details: React.ComponentType<ConditionTypeDetailsProps<LoyaltyEarnedState>>,
): ConditionType<LoyaltyEarnedState, Condition.LoyaltyEarned> => ({
  name: "Loyalty",
  description(state) {
    const measureWording =
      state.measureOption == LoyaltyEarnedMeasureOption.PERCENT
        ? "%"
        : "in your currency";

    return `Loyalty by ${state.value} ${measureWording} or greater`;
  },
  Details(props: ConditionTypeDetailsProps<LoyaltyEarnedState>) {
    return React.createElement(Details, props);
  },
  empty: { measureOption: LoyaltyEarnedMeasureOption.PERCENT, value: 10 },
  fromModel(model: Condition.LoyaltyEarned) {
    return loyaltyEarnedFromModel(model);
  },
  toModel(state) {
    return {
      type: Condition.LOYALTY_EARNED,
      measureOption: state.measureOption,
      value: state.value,
    };
  },
  valid(state) {
    return validateLoyaltyEarnedCondition(state).valid;
  },
});

export { type LoyaltyEarnedState } from "@redotech/redo-model/return-flow/condition-validate";
